import { createSelector } from "reselect";
import { isEmpty, forIn } from "lodash";
import { updateObject, addPaddingZero } from "../../_utils";
//EXTRACT THE PART OF THE STATE
const defaultStat = {
  views: "None",
  likes: "None",
  interests: "None",
  shortlist: "None",
  saved: "None",
  favorite: "None"
};
const getData = state => {
  const profile = state.user.profile;
  if (isEmpty(profile)) {
    return defaultStat;
  }

  let updatedStat = {};

  updatedStat.views = addPaddingZero(profile.profileViews);
  updatedStat.likes = addPaddingZero(profile.likes);
  updatedStat.interests = addPaddingZero(profile.expressInterests);
  updatedStat.shortlist = addPaddingZero(profile.shortlists);
  updatedStat.saved = addPaddingZero(profile.saves);
  updatedStat.favorite = addPaddingZero(profile.favorites);

  return updateObject(defaultStat, updatedStat);
};
//VERIFY IF THE JWT IS SET
const getMyProfileStat = createSelector(getData, stat => stat);
export default getMyProfileStat;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyProfileStat.js